angular.module('picmonicng').directive('factCharacterImageGroup', [
  '$q',
  function ($q) {
    return {
      restrict: 'E',
      replace: true,
      template: '<canvas class="character-image"></canvas>',
      scope: {
        characters: '=',
        size: '@',
      },
      link: function (scope, element, attrs) {
        var canvas = element[0];
        var ctx = canvas.getContext('2d');
        var sizeRatio = 1;
        var sizeSuffix = '';

        //handle mirroring

        scope.images = [];

        switch (scope.size) {
          case 'md':
            sizeRatio = 0.75;
            sizeSuffix = '_threequarter';
            break;
          case 'sm':
            sizeRatio = 0.5;
            sizeSuffix = '_half';
            break;
          case 'xs':
            sizeRatio = 0.25;
            sizeSuffix = '_quarter';
            break;
          default:
            sizeRatio = 1;
            break;
        }

        var minX = 2200,
          minY = 2200;
        var maxX = 0,
          maxY = 0;
        angular.forEach(scope.characters, function (character) {
          minX = Math.min(minX, character.character_x + character.crop_x);
          minY = Math.min(minY, character.character_y + character.crop_y);
          maxX = Math.max(maxX, character.character_x + character.crop_x + character.crop_width);
          maxY = Math.max(maxY, character.character_y + character.crop_y + character.crop_height);
          for (var x in character.assets) {
            scope.images.push(
              $q(function (resolve, reject) {
                var asset = character.assets[x];
                var img = new Image();

                img.addEventListener('load', function () {
                  resolve({ asset: asset, image: img, character: character });
                });

                img.addEventListener('error', function () {
                  reject({ asset: asset, image: img, character: character });
                });
                img.src = asset.image_url.replace('picmonic_assets', 'picmonic_assets' + sizeSuffix);
              })
            );
          }
        });

        canvas.width = (maxX - minX) * sizeRatio;
        canvas.height = (maxY - minY) * sizeRatio;

        $q.all(scope.images).then(function (images) {
          images.sort(function (a, b) {
            return a.z - b.z || a.asset.z - b.asset.z;
          });
          angular.forEach(images, function (image) {
            var a = image.asset;
            var c = image.character;
            var scaleX = c.character_width / c.original_width;
            var scaleY = c.character_height / c.original_height;

            var sx = Math.max(c.crop_x / scaleX - a.x, 0);
            var sy = Math.max(c.crop_y / scaleY - a.y, 0);
            var sx2 = Math.min((c.crop_x + c.crop_width) / scaleX, a.x + a.width) - a.x;
            var sy2 = Math.min((c.crop_y + c.crop_height) / scaleY, a.y + a.height) - a.y;
            var sw = sx2 - sx;
            var sh = sy2 - sy;
            var sxx = c.mirrored_y ? a.width - sx - sw : sx;
            var syy = c.mirrored_x ? a.height - sy - sh : sy;
            var charX = c.character_x + c.crop_x + a.x - minX;
            var charY = c.character_y + c.crop_y + a.y - minY;

            var scaleH = c.mirrored_y ? -1 : 1;
            var scaleV = c.mirrored_x ? -1 : 1;

            ctx.save();
            ctx.scale(scaleH, scaleV);
            ctx.drawImage(
              image.image,
              sxx * sizeRatio, //sx
              syy * sizeRatio, //sy
              sw * sizeRatio, //swidth
              sh * sizeRatio, //sheight
              charX * sizeRatio * scaleH, //dx
              charY * sizeRatio * scaleV, //dy
              sw * scaleX * sizeRatio * scaleH, //dwidth
              sh * scaleY * sizeRatio * scaleV //dheight
            );
            ctx.restore();
          });
        });
      },
    };
  },
]);
